import { ReactComponent as FixingSvg } from '../assets/ilustraciones/fixing.svg'

type ErrorCardProps = {
    title: string;
    text: string;
}

const ErrorCard = ({ title, text }: ErrorCardProps) => {
    return (
        <div className='bg-white rounded-xl py-5 px-4 flex flex-col gap-4 items-center mx-8 mt-6 font-libre-franklin font-bold text-blue_text text-center'>
            <FixingSvg />
            <div className='text-2xl mt-4'>{title}</div>
            <div className='font-roboto font-normal text-[#0C0D0F]'>{text}</div>
        </div>
    )
}

export default ErrorCard
